/** URL helper utilities for extracting and formatting URL information */

/**
 * Extract base domain from a full URL
 *
 * @param url Full URL (e.g., "https://www.nytimes.com/article/foo")
 * @returns Base domain (e.g., "nytimes.com") or null if invalid
 */
export const getBaseUrlFromLink = (url: string | undefined): string | null => {
  if (!url) return null;
  try {
    const urlObj = new URL(url);
    // Remove 'www.' prefix if present for cleaner display
    return urlObj.hostname.replace(/^www\./, '');
  } catch {
    // If URL parsing fails, return null
    return null;
  }
};
